import {
  Autocomplete,
  Card,
  CardContent,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
} from '@mui/material';
import MWUploader from 'components/MWUploader';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { toggleAppBarLoading } from 'reduxStore/appLoader/toggleAppBarLoadingSlice';
import { CostCenter } from 'reduxStore/getSchemeList/Model';
import { useAppDispatch, useAppSelector } from 'reduxStore/hooks';
import { addPatientDataDetails } from 'reduxStore/patientDataDetails/addPatientDataDetails/addPatientDataDetailsSlice';
import { AddPatientDataDetailsBody } from 'reduxStore/patientDataDetails/addPatientDataDetails/Model';
export default function SchemeCard() {
  const dispatch = useAppDispatch();

  const [isApiProcessing, setIsApiProcessing] = useState(false);
  const addPointDataDetailsRes = useAppSelector((state: any) => state.addPointDataDetailsRes);
  const searchPatientDetailsByDocumentIdResponse = useAppSelector(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (state: any) => state.searchPatientDetailsByDocumentIdRes,
  );

  const [schemeList, setSchemeList] = useState([] as any[]);
  const [selectedScheme, setSelectedScheme] = useState<any>(null);
  const updateSelectedScheme = (passedVal: SelectChangeEvent) => {
    setSelectedScheme(passedVal.target.value as string);
  };
  const [schemeCardNumber, setSchemeCardNumber] = useState('');

  const [isEdit, setIsEdit] = useState(false);
  const [isEnableSubmit, setEnableSubmit] = useState(true);
  const [idValues, setIdValues] = useState([] as any[]);
  const [selectedIdProofValue, setSelectedIdProofValue] = useState<number | null>(null);
  const [govtIdTypeError, setGovtIdTypeError] = useState('');
  const idProofValueFromChild = async (idproofval: any) => {
    setSelectedIdProofValue(idproofval);
  };
  const [idValue, setIdValue] = useState('');
  const [govtIdNumberError, setGovtIdNumberError] = useState('');

  const [govtImgId, setGovtImgId] = useState('');
  const updateGovtDataStateFromChild = async (documentId: any) => {
    setGovtImgId(documentId);
    if (govtImgId !== documentId) {
      dispatch(
        addPatientDataDetails({
          patientId: '23',
          description: `VerificationDocument: Scheme_Card-${schemeCardNumber}`,
          startDate: dayjs(String(new Date())).format('YYYY-MM-DDTHH:mm:ss'),
          patientDocumentId: String(documentId),
        } as AddPatientDataDetailsBody),
      );
    }
  };
  const [govtImageInfo, setGovtImageInfo] = useState('');

  // const getDemographicsDetailsByPtIdRes = useAppSelector(
  //   (state) => state.getDemographicsDetailsByPtId,
  // );
  useEffect(() => {
    //   getDemographicsDetailsByPtIdRes?.getDemographicsDetailsByPtIdRes?.personalDetails?.idProof
    //     ?.idType?.value !== undefined
    //     ? setSelectedIdProofValue(
    //         getDemographicsDetailsByPtIdRes?.getDemographicsDetailsByPtIdRes?.personalDetails?.idProof
    //           ?.idType?.value,
    //       )
    //     : setSelectedIdProofValue(null);
    //   getDemographicsDetailsByPtIdRes?.getDemographicsDetailsByPtIdRes?.personalDetails?.idProof
    //     ?.idNumber !== undefined
    //     ? setIdValue(
    //         getDemographicsDetailsByPtIdRes?.getDemographicsDetailsByPtIdRes?.personalDetails?.idProof
    //           ?.idNumber,
    //       )
    //     : setIdValue('');
    //   getDemographicsDetailsByPtIdRes?.getDemographicsDetailsByPtIdRes?.personalDetails?.idProof
    //     ?.supportingDocuments?.document !== undefined
    //     ? setGovtImageInfo(
    //         getDemographicsDetailsByPtIdRes?.getDemographicsDetailsByPtIdRes?.personalDetails?.idProof
    //           ?.supportingDocuments?.document,
    //       )
    //     : setGovtImageInfo('');
    // }, [getDemographicsDetailsByPtIdRes]);
    setGovtImageInfo('');
  }, []);
  // Call Govt Id type store
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const getGovtIDProofStoreValue = useAppSelector((state: any) => state.govtIdProofList);
  // Get Govt. ID List
  useEffect(() => {
    if (getGovtIDProofStoreValue?.govtIdProofResponse?.govtIdTypeList !== undefined) {
      setIdValues(getGovtIDProofStoreValue?.govtIdProofResponse.govtIdTypeList);
    } else setIdValues([] as any[]);
  }, [getGovtIDProofStoreValue]);

  const [checkImgUpload, setCheckImgUpload] = useState(false);
  // Get PreviewImg Details
  const viewPreviewImageData = (passedVal: boolean) => {
    setCheckImgUpload(passedVal);
  };

  // const [delImg, setDelImg] = useState(false);
  const [delImgAction, setDelImgAction] = useState(false);

  const updateDeleteImg = (passedVal: boolean) => {
    setDelImgAction(passedVal);
  };
  // const delImgAction = (passeVal: boolean) => {
  //   setDelImg(passeVal);
  // };

  // const showDocument = () => {
  //   setDescriptionModalActive(true);
  // };
  // Call govt. image update Body
  const updateGovtIdImg = () => {
    if (delImgAction) {
      setDelImgAction(false);
      // When user delete image
      if (selectedIdProofValue === null && idValue === '') {
        setGovtIdTypeError('Please select a id ');
        setGovtIdNumberError('Please enter id  number');
      } else if (selectedIdProofValue === null && idValue !== '') {
        setGovtIdTypeError('Please select a id ');
        setGovtIdNumberError('');
      } else if (selectedIdProofValue !== null && idValue === '') {
        setGovtIdTypeError('');
        setGovtIdNumberError('Please enter id  number');
      } else {
        setGovtIdTypeError('');
        setGovtIdNumberError('');
        // const govtIdUpdateBody = {
        //   healthRecordId: patientid,
        //   govtIdNumber: idValue,
        //   govtIdType: String(selectedIdProofValue),
        //   govtIdImage: '-1',
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        // } as any;
        // dispatch(updateDemographicsDetailsByPatientId(govtIdUpdateBody));
      }
    } else {
      if (govtImgId !== undefined) {
        // when user add new image
        if (selectedIdProofValue === null && idValue === '') {
          setGovtIdTypeError('Please select a id ');
          setGovtIdNumberError('Please enter id  number');
        } else if (selectedIdProofValue === null && idValue !== '') {
          setGovtIdTypeError('Please select a id ');
          setGovtIdNumberError('');
        } else if (selectedIdProofValue !== null && idValue === '') {
          setGovtIdTypeError('');
          setGovtIdNumberError('Please enter id  number');
        } else {
          setGovtIdTypeError('');
          setGovtIdNumberError('');
          // const govtIdUpdateBody = {
          //   healthRecordId: patientid,
          //   govtIdNumber: idValue,
          //   govtIdType: String(selectedIdProofValue),
          //   govtIdImage: String(govtImgId),
          // } as any;
          // dispatch(updateDemographicsDetailsByPatientId(govtIdUpdateBody));
        }
      } else {
        // when user edit other details
        if (selectedIdProofValue === null && idValue === '') {
          setGovtIdTypeError('Please select a id ');
          setGovtIdNumberError('Please enter id  number');
        } else if (selectedIdProofValue === null && idValue !== '') {
          setGovtIdTypeError('Please select a id ');
          setGovtIdNumberError('');
        } else if (selectedIdProofValue !== null && idValue === '') {
          setGovtIdTypeError('');
          setGovtIdNumberError('Please enter id  number');
        } else {
          setGovtIdTypeError('');
          setGovtIdNumberError('');
          // const govtIdUpdateBody = {
          //   healthRecordId: patientid,
          //   govtIdNumber: idValue,
          //   govtIdType: String(selectedIdProofValue),
          // } as any;
          // dispatch(updateDemographicsDetailsByPatientId(govtIdUpdateBody));
        }
      }
    }
  };

  const getSchemeListResponse = useAppSelector(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (state: any) => state.getSchemeListRes,
  );
  useEffect(() => {
    dispatch(toggleAppBarLoading(getSchemeListResponse?.loading));
    if (getSchemeListResponse?.schemeListRes?.data !== undefined) {
      if (getSchemeListResponse?.schemeListRes?.data.length > 0) {
        setSchemeList(getSchemeListResponse?.schemeListRes?.data);
      } else setSchemeList([] as any[]);
    } else setSchemeList([] as any[]);
  }, [getSchemeListResponse]);

  return (
    <Card>
      <CardContent>
        <Grid
          container
          direction='column'
          justifyContent='flex-start'
          alignItems='stretch'
          spacing={1}
        >
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <FormControl fullWidth size='small'>
              <InputLabel id='cost-center-select-label'>Scheme</InputLabel>
              <Select
                labelId='cost-center-select-label'
                id='cost-center-select'
                value={selectedScheme}
                label='Scheme'
                onChange={updateSelectedScheme}
                disabled={
                  getSchemeListResponse?.loading ||
                  searchPatientDetailsByDocumentIdResponse?.loading ||
                  isApiProcessing ||
                  addPointDataDetailsRes?.loading
                }
                placeholder='Select Scheme'
                // Show a spinner inside the select if loading
                IconComponent={(iconProps) =>
                  getSchemeListResponse?.loading ? (
                    <CircularProgress size={20} sx={{ mr: 2 }} />
                  ) : (
                    <ArrowDropDownIcon {...iconProps} />
                  )
                }
              >
                {schemeList.length === 0 && !getSchemeListResponse?.loading ? (
                  <MenuItem disabled>No Scheme Found</MenuItem>
                ) : (
                  schemeList.map((cc: CostCenter) => (
                    <MenuItem key={cc.name} value={cc.name}>
                      {cc.name}
                    </MenuItem>
                  ))
                )}
              </Select>
            </FormControl>
          </Grid>
          {selectedScheme !== null && (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <TextField
                label='Scheme Name'
                placeholder='Enter Scheme Name'
                variant='outlined'
                size='small'
                value={schemeCardNumber}
                onChange={(event: any) => setSchemeCardNumber(event.target.value)}
                disabled={
                  getSchemeListResponse?.loading ||
                  searchPatientDetailsByDocumentIdResponse?.loading ||
                  isApiProcessing ||
                  addPointDataDetailsRes?.loading
                }
                fullWidth
              />
            </Grid>
          )}
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <MWUploader
              documentType='patient-id-Image'
              criteria='Document size should be maximum 10MB.'
              updatedDataState={updateGovtDataStateFromChild}
              title="Update Patient's Parent Scheme Card"
              visibility={isEdit}
              imageUrl={govtImageInfo}
              docImg={govtImageInfo}
              deleteImgAction={delImgAction}
              previewImageData={viewPreviewImageData}
              deleteUploadedImg={updateDeleteImg}
              onLoadingChange={(loading) => setIsApiProcessing(loading)}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
